import { render, staticRenderFns } from "./ConfigModal.vue?vue&type=template&id=19f463ee&scoped=true&"
import script from "./ConfigModal.vue?vue&type=script&lang=js&"
export * from "./ConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigModal.vue?vue&type=style&index=0&id=19f463ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f463ee",
  null
  
)

export default component.exports